/**
 * Canonical category slugs for marketing_articles + their i18n keys.
 * Used by every Resources page for consistent labels and ordering.
 */

export const RESOURCE_CATEGORIES = [
  { slug: "guides", i18n: "guides" },
  { slug: "comparatifs", i18n: "comparatifs" },
  { slug: "etudes-de-cas", i18n: "etudesDeCas" },
  { slug: "ia-redaction", i18n: "iaRedaction" },
  { slug: "seo-visibilite", i18n: "seoVisibilite" },
  { slug: "conformite-rgpd", i18n: "conformiteRgpd" },
] as const;

export type ResourceCategorySlug = (typeof RESOURCE_CATEGORIES)[number]["slug"];

export function isResourceCategorySlug(value: string): value is ResourceCategorySlug {
  return RESOURCE_CATEGORIES.some((c) => c.slug === value);
}
